import * as React from "react";
import { ClipboardUtil } from "./ClipboardUtil";
export interface ICopyToClipboardButtonProps {
    text: string;
}
export class CopyToClipboardButtonComponent extends React.Component<ICopyToClipboardButtonProps, any> {
    constructor(props: ICopyToClipboardButtonProps) {
        super(props);
    }
    render() {
        return (<button className="btn btn-info btn-xs pull-right copy-content-button no-print" title="Copy to clipboard" 
        onClick={()=> {ClipboardUtil.toClipboard(this.props.text);}}>
            <i className="fa fa-copy"></i>
        </button>);
    }
}